/*global qq */
qq.version = "5.16.0-alpha.14";
